export const isEnterPress = (event: React.KeyboardEvent) =>
  event.key === "Enter";

export const isTabPress = (event: React.KeyboardEvent) => event.key === "Tab";
